<template>
  <div class="cus-modal" v-loading="loading">
    <div class="wrap">
      <OmsForm :form-config="formConfig" />
      <OmsTable 
        :jordan-table-config="tableConfig"
        @on-select="onSelect"
        @on-select-cancel="onSelectCancel"
        @on-select-all="onSelectAll"
        @on-select-all-cancel="onSelectAllCancel" 
      />
    </div>
    <OmsButton :btn-config="btnConfig" class="modal-footer" />
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: 'giftExchangeResetNum',
  props: {
    componentData: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapState('global', ['userInfo']),
  },
  data() {
    return {
      loading: false,
      formConfig: {
        formValue: {
          title: '',
        },
        formData: [
          {
            style: 'input',
            label: t('邮件标题'),
            value: 'title',
            width: '12',
          },
        ]
      },
      drpdata: {},
      dataEmptyMessage: t('无数据'),
      tableConfig: {
        pageShow: false, // 控制分页是否显示
        // btnsShow: false, // 控制操作按钮是否显示
        indexColumn: true,
        isShowSelection: true,
        multiple: true,
        border: true, // 是否显示纵向边框
        data: [],
        selectionData: [],
        columns: [
          {
            title: t('申请日期'),
            key: 'applyTime',
            render: (h, params) => {
              return h('span', {}, params.row.applyTime)
            }
          },
          {
            title: t('店铺名称'),
            key: 'shopName',
          },
          {
            title: t('平台单号'),
            key: 'tid',
          },
          {
            title: t('小二单号'),
            key: 'newTid',
          },
          {
            title: t('支付时间'),
            key: 'payTime',
          },
          {
            title: t('支付金额'),
            key: 'payAmt',
          },
          {
            title: t('兑换类型'),
            key: 'giftType',
            width: 130,
            render: (h, params) => {
              const arr = [
                { label: t('赠品兑换'), value: 1 },
                { label: t('客情兑换'), value: 2 },
              ]
              const options = arr.map(item => h('Option', { props: item }));
              return h('Select', {
                props: {
                  transfer: true,
                  clearable: false,
                  value: params.row.giftType,
                },
                on: {
                  'on-change': (val, e) => {
                    params.row.giftType = val
                    this.tableConfig.data[params.index] = params.row;
                  }
                }
              }, options)
            }
          },
          {
            title: t('主品名称'),
            key: 'skuName',
          },
          {
            title: t('主品SKU'),
            key: 'skuCode',
          },
          {
            title: t('赠品名称'),
            key: 'giftSkuName',
            width: 200,
            render: (h, params) => {
              return h('div', {
                  style: {
                    padding: '6px 0',
                  }
                }, [
                h('Input', {
                  props: {
                    type: 'textarea',
                    rows: 2,
                    value: params.row.giftSkuName,
                  },
                  on: {
                    'on-change': (e) => {
                      params.row.giftSkuName = e.target.value;
                      this.tableConfig.data[params.index] = params.row;
                    },
                  },
                })
              ])
            }
          },
          {
            title: t('申请原因'),
            key: 'reason',
            width: 200,
            render: (h, params) => {
              return h('div', {
                  style: {
                    padding: '6px 0',
                  }
                }, [
                h('Input', {
                  props: {
                    type: 'textarea',
                    rows: 2,
                    value: params.row.reason,
                  },
                  on: {
                    'on-change': (e) => {
                      params.row.reason = e.target.value;
                      this.tableConfig.data[params.index] = params.row;
                    },
                  },
                })
              ])
            }
          },
          {
            title: t('申请人'),
            key: 'applyName',
          },
        ]
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            loading: false,
            btnclick: () => {
              this.save();
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    save() {
      if (!this.tableConfig.selectionData.length) return $fcWarn({ content: t('请选择重置兑换的商品') })
      const arr = this.tableConfig.selectionData.map(i => i._Idx)
      const exchangeInfoList = this.tableConfig.data.filter(i => arr.includes(i._Idx))
      let hasEmpty = false
      for (let item of exchangeInfoList) {
        if (item.giftSkuName == '') {
          $fcWarn({ content: t('请维护【{}】赠品名称', item.skuCode) })
          hasEmpty = true
          break;
        }
      }
      if (hasEmpty) return
      const params = {
        title: this.formConfig.formValue.title,
        exchangeInfoList
      }
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/gift/num/confirm', params).then(res => {
        if (res.data.code === 0) {
          this.$parent.$parent.closeConfirm();
          $fcSuccess({
            title: t('申请兑换次数'),
            content: t('申请兑换次数已经发邮件给对应负责人，请线下联系确认'),
            onOk: () => {
              this.$parent.$parent.$parent.getData();
              this.$parent.$parent.$parent.selection = [];
            }
          });
        }
      })
    },
    // 获取数据-重置兑换次数申请
    init() {
      const { title, exchangeInfoList = [] } = this.componentData.data || {}
      this.formConfig.formValue.title = title
      this.tableConfig.data = exchangeInfoList.map((i, index) => {
        i.applyTime = $utils.dateFormat(new Date(), 'yyyy-MM-dd') // 申请日期
        i.applyName = this.userInfo.name // 申请人
        i._prohibitClickToSelect = true
        i._Idx = index
        return i
      })
    },
    async getSku(skuId) {
      return new Promise(async (resolve) => {
        const res = await this.service.common.publicUrlParams(`/api/cs/oc/oms/v1/gift/sku/info/select?skuId=${skuId}`)
        if (res.data.code == 0 && res.data.data) {
          resolve(res.data.data)
        }
      })
    },
    // 子表【明细】表格列-条码
    async getFkData(keyword = '', pageNum = 1) {
      const self = this;
      let res = null,
        result = [],
        tabth = [];
      let range = Number(localStorage.getItem('fkRange'))
      const searchdata = {
        range,
        startindex: (pageNum - 1) * range,
        refcolid: 174272,
        isdroplistsearch: true,
      };
      keyword != '' && (searchdata.ak = keyword);
      const param = new FormData();
      param.append('searchdata', JSON.stringify(searchdata));
      param.append('date', new Date().getTime());
      res = await self.service.financeCenter.newQueryList(param);
      const {
        data: { datas, code, message },
      } = res;
      if (code != 0) {
        this.dataEmptyMessage = t('未查询到数据');
        return;
      } else {
        tabth = datas.tabth;
        result = datas.row;
      }
      const renderObj = {
        start: 0,
        tabth,
        row: result,
        totalRowCount: datas.rowCount || 0,
      };
      this.drpdata = renderObj;
      this.dataEmptyMessage = message;
    },
    // 选中某一项时触发
    onSelect(selection) {
      this.tableConfig.selectionData = selection
    },
    // 取消选中某一项时触发
    onSelectCancel(selection) {
      this.tableConfig.selectionData = selection
    },
    // 点击全选时触发
    onSelectAll(selection) {
      this.tableConfig.selectionData = selection
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection) {
      this.tableConfig.selectionData = [];
    },
  }
}
</script>
<style lang="less" scoped>
.cus-modal {
  .wrap {
    max-height: 80vh;
    overflow-y: auto;
  }
  /deep/ textarea.ark-input {
    font-size: 12px;
  }
}
</style>